module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pe-d64e9732fcaa8f765994a9a7ff9f07f6.svg";